import { createHook, createComponent } from 'reakit-system';
import {
  Paragraph,
  ParagraphHTMLProps,
  ParagraphOptions,
  useParagraph,
} from '../../Paragraph/Paragraph';

export type ThankYouMessageOptions = ParagraphOptions & {
  sent: 'all' | 'rating';
};
export type ThankYouMessageHTMLProps = ParagraphHTMLProps;
export type ThankYouMessageProps = ThankYouMessageOptions &
  ThankYouMessageHTMLProps;

let NBSP = '\u00A0';

let useThankYouMessage = createHook<
  ThankYouMessageOptions,
  ThankYouMessageHTMLProps
>({
  keys: ['sent'],
  compose: [useParagraph],
  useOptions(options) {
    return { ...options, styles: { ...options.styles, outline: 'none' } };
  },
  useProps(options, props) {
    if (props.children) {
      return { ...props, tabIndex: -1 };
    }
    return {
      ...props,
      children: `Спасибо за вашу оценку${
        options.sent === 'all' ? ` и${NBSP}комментарий` : ''
      }!`,
      tabIndex: -1,
    };
  },
});

export let ThankYouMessage = createComponent({
  as: Paragraph,
  useHook: useThankYouMessage,
  memo: true,
});
